import Spacer from "@/components/atoms/spacer"
import Container from "@/components/templates/container"

const Description = ({
    description
}) => {
  const baseContainer = 'relative w-full my-mediumMobile lg:my-mediumDesktop'
  const base = 'w-full max-w-[1200px] mx-auto text-bodyMobile md:text-body2Desktop text-umber text-center font-chivoMono'

  return (
    <Container outerClassName="mt-largeMobile lg:mt-largeDesktop">
      <Spacer />
      <div className={baseContainer}>
        <p className={base}>
          {description}
        </p>
      </div>
      <Spacer />
    </Container>
  )
}

export default Description
